import React from 'react';

export default function LayoutFullLoading(props:any) {

    const imgStyle = {
        marginTop: gd.layout.top.height+'px'
    };

    return (
        <div className="ui-loading full">
            <div className="gd-loading">
                <img src="/app/web/skin/common/loader/app-loading.gif?43" style={imgStyle} />
                    <p>Loading ...</p>
            </div>
        </div>
    );


}
